import { render, staticRenderFns } from "./OntInfo.vue?vue&type=template&id=7e49ba79&"
import script from "./OntInfo.vue?vue&type=script&lang=js&"
export * from "./OntInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports